import { ApiCallError } from 'app/http/ApiCallError';

export const getTopUpLoadErrorMessage = (error: unknown): string | null => {
  if (error instanceof ApiCallError && error.status === 401) {
    return null;
  }
  if (error instanceof ApiCallError && error.status === 403) {
    return 'You do not have access to this billing account';
  }
  return 'Unable to load payment methods. Please try again.';
};
